import { request } from '@/utils'
import { stringify } from 'query-string'
export const getHtmlInfo = async <T, D>(data: T) => {
  return await request<T, D>({ method: 'POST', url: '/html5/view', data })
}

const BASE_URL = process.env.REACT_APP_PMS_API_URL
// console.log(process.env.REACT_APP_PMS_API_URL, 'process.env.REACT_APP_PMS_API_URL')

// 参加邀请
export const submitInvitation = async (data: any) => {
  return await request<any, any>(
    {
      baseURL: BASE_URL,
      method: 'POST',
      url: '/conference/apply',
      data: stringify(data),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    },
    { formType: false },
  )
}

// 签到
export const signIn = async (data: any) => {
  return await request<any, any>(
    {
      baseURL: BASE_URL,
      method: 'POST',
      url: '/conference/signin',
      data: stringify(data),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    },
    { formType: false },
  )
}

// 校验
export const check = async (data: any) => {
  return await request<any, any>(
    {
      baseURL: BASE_URL,
      method: 'POST',
      url: `/conference/query?phone=${data.phone}`,
    },
    { formType: false },
  )
}
// 校验
export const checkSign = async (data: any) => {
  return await request<any, any>(
    {
      baseURL: BASE_URL,
      method: 'POST',
      data: stringify(data),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      url: '/conference/signin',
    },
    { formType: false },
  )
}

export const getActivityJsonConfig = async (url: string) => {
  return await request<any, any>({ method: 'GET', url })
}
